import { render, staticRenderFns } from "./AccountStoreBlackListAddPop.vue?vue&type=template&id=193e94bd&"
import script from "./AccountStoreBlackListAddPop.vue?vue&type=script&lang=js&"
export * from "./AccountStoreBlackListAddPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports